export const pushTestUserCacheKey = (endpoint, environment, owner) => owner
    ? `push-test-users:v1:${JSON.stringify([endpoint || '', environment || '', String(owner)])}`
    : null;

const userIdentity = (user) => ({ userId: user.userId, email: user.email || '', username: user.username || '' });
const validUser = (user) => user && typeof user.userId === 'string' && !!user.userId
    && ['email', 'username'].every((field) => user[field] === undefined || typeof user[field] === 'string');
const emptyCache = () => ({ identifier: '', keyword: null, matches: [], recipients: [] });

export function readPushTestUsers(key) {
    if (!key) return emptyCache();
    try {
        const data = JSON.parse(window.localStorage.getItem(key));
        if (data?.version !== 1 || typeof data.identifier !== 'string'
            || !(data.keyword === null || typeof data.keyword === 'string')
            || !Array.isArray(data.matches) || !data.matches.every(validUser)
            || !Array.isArray(data.recipients) || !data.recipients.every(validUser)) return emptyCache();
        return {
            identifier: data.identifier, keyword: data.keyword,
            matches: data.matches.slice(0, 10).map(userIdentity),
            recipients: [...new Map(data.recipients.map((user) => [user.userId, userIdentity(user)])).values()],
        };
    } catch {
        return emptyCache();
    }
}

export function writePushTestUsers(key, snapshot) {
    if (!key) return;
    try {
        // Persist identities only; device tokens and delivery state are refreshed on open.
        window.localStorage.setItem(key, JSON.stringify({
            version: 1, identifier: snapshot.identifier, keyword: snapshot.keyword,
            matches: snapshot.matches.slice(0, 10).map(userIdentity),
            recipients: snapshot.recipients.map(userIdentity),
        }));
    } catch {
        // Storage can be unavailable; searching and sending still work in memory.
    }
}
